import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
export default class FileManagementService extends ApiService {
  template = "defaultTemplate";
  DOMAIN = -40;
  icon = "RedCabinet";
  favicon = "FolderHorizontalClosed";
  singular = this.terminology.file.singular;
  plural = this.terminology.file.plural;
  vowel = this.terminology.file.vowel;
  Width = 690;
  gemItems = [
    {
      key: "create",
      label: "Create Drawer",
      icon: PrimeIcons.PLUS_CIRCLE,
      services: -1,
    },
    {
      key: "create",
      label: "Create Folder",
      icon: PrimeIcons.PLUS_CIRCLE,
      services: -2,
      domain: 169,
    },
  ];

  constructor() {
    super("folders");
  }
}
